import { Badge, Button, Dropdown, Input, MenuProps } from 'antd';
import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import classes from './RoomsTab.module.scss';
import colors from '../../../scss/variables/colors.module.scss';
import RowLoader from 'components/Sceletons/RowLoader';
import Assests from 'assets/icons';
import { ERoomFilters } from 'interfaces/IDataRoom';

type Props = {
  setIsVisibleModal: Dispatch<SetStateAction<boolean>>;
  setSearchValue: Dispatch<SetStateAction<string>>;
  searchValue: string;
  isLoadingUserData: boolean;
  setFilterValue: React.Dispatch<React.SetStateAction<ERoomFilters>>
  filterValue: ERoomFilters;
};

export default function RoomsTabControl({
  setIsVisibleModal,
  searchValue,
  setSearchValue,
  isLoadingUserData,
  setFilterValue,
  filterValue,
}: Props) {
  const { t } = useTranslation();

  const openNewRoomCreator = () => {
    // RETURNED BILLING
    setIsVisibleModal(true);
    //
  };

  const onSearch = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value);
  };

  const items: MenuProps['items'] = [
    {
      key: ERoomFilters.All,
      label: t('sidebar.roomsSidebar.all'),
      className: filterValue === ERoomFilters.All ? classes.activeFilter : 'null',
      onClick: (e) => setFilterValue(e.key as ERoomFilters),
    },
    {
      key: ERoomFilters.Administrator,
      label: t('sidebar.roomsSidebar.admin'),
      className: filterValue === ERoomFilters.Administrator ? classes.activeFilter : 'null',
      onClick: (e) => setFilterValue(e.key as ERoomFilters),
    },
    {
      key: ERoomFilters.Owner,
      label: t('sidebar.roomsSidebar.owner'),
      className: filterValue === ERoomFilters.Owner ? classes.activeFilter : 'null',
      onClick: (e) => setFilterValue(e.key as ERoomFilters),
    },
    {
      key: ERoomFilters.Member,
      label: t('sidebar.roomsSidebar.member'),
      className: filterValue === ERoomFilters.Member ? classes.activeFilter : 'null',
      onClick: (e) => setFilterValue(e.key as ERoomFilters),
    },
  ];  

  return (
    <div className={classes.management}>
      {isLoadingUserData ? (
        <RowLoader width={600} padding={'0 0 0 0'} height={32} borderradius={5}/>
      ) : (
        <>
          <Input
            suffix={<Assests.SearchIcon className={classes.management_searchIcon} />}
            type='search'
            allowClear
            style={{paddingRight: 2}}
            placeholder={t('Rooms.searchHolder')}
            value={searchValue}
            onChange={onSearch}
          />

          <Badge
            color={colors.primary100}
            offset={[-13, 8]}
            dot={filterValue !== 'all' ? true : false}
          >
            <Dropdown
              menu={{ items }}
              trigger={['click']}
              placement='bottomLeft'
            >
              <Button
                className={classes.management_filter}
                icon={<Assests.FilterIcon/>}
                id='rooms-filter-btn'
                type='text'
              />
            </Dropdown>
          </Badge>
          
          <Button
            className={classes.management_newRoom}
            icon={<Assests.RoomsAddIcon />}
            shape='circle'
            type='primary'
            data-testid='sidebar-create-room-btn'
            onClick={openNewRoomCreator}
          />
        </>
      )}
    </div>
  );
}
